export class Push {
    id?: string;
    title: string;
    body: string;
    sendDate: Date;
    idJob?: number;
    topic?: string;

    constructor(title: string, body: string, sendDate: Date = (null as any)) {
        this.title = title;
        this.body = body;
        this.sendDate = sendDate;
    }
}

